// @ts-nocheck
/* eslint-disable max-lines-per-function */

import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getIssuesTranslationKey } from '@/components/PDCPageComponent';
import { getSelectedInspection } from '@/selectors';

const BaseComponent = ({ pdc = {} }) => {
    const { damagesCount, criticalDamagesCount } = pdc;

    return (
        <div className='row' data-testid='damages-header-container'>
            <div className='display-flex'>
                <div className='col-lg-6 margin-bottom-10'>
                    <div className='text-size-small text-color-gray'>
                        <FormattedMessage id='intl-msg:pdc.table.header.criticalIssueCount' />
                    </div>
                    <div className={`text-color-${criticalDamagesCount && 'danger text-bold'}`}>
                        {criticalDamagesCount ? (
                            <span>
                                <i className='uikit-icon icon-warning-sign' />
                                &nbsp;
                            </span>
                        ) : (
                            ''
                        )}
                        <FormattedMessage
                            id={getIssuesTranslationKey(criticalDamagesCount)}
                            values={{ issueCount: criticalDamagesCount }}
                        />
                    </div>
                </div>
                <div className='col-lg-6 margin-bottom-10'>
                    <div className='text-size-small text-color-gray'>
                        <FormattedMessage id='intl-msg:pdc.table.header.issueCount' />
                    </div>
                    <div className={`text-color-${damagesCount && 'warning text-bold'}`}>
                        <FormattedMessage
                            id={getIssuesTranslationKey(damagesCount)}
                            values={{ issueCount: damagesCount }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

BaseComponent.propTypes = {
    pdc: PropTypes.object.isRequired,
};

const DamagesHeaderContainer = props => {
    const pdc = useSelector(getSelectedInspection);

    return <BaseComponent {...props} pdc={pdc} />;
};

export { BaseComponent };
export default injectIntl(DamagesHeaderContainer);
